import Companies from 'screens/Companies';
import Company from 'screens/Companies/Company';
import CompanyView from 'screens/Companies/Company/components/CompanyView';
import { paths } from 'routes/paths';
import { ROLES } from 'utilities/access';

const navRoutes = [
  {
    id: 'companies',
    key: 'companies',
    path: paths.companies,
    exact: true,
    secure: true,
    disabled: false,
    component: Companies
  }
];

const allRoutes = [
  ...navRoutes,
  {
    id: 'companyEntry',
    key: 'companyEntry',
    path: `${paths.companies}/:id`,
    exact: true,
    secure: true,
    component: Company,
    minPermissions: {
      minAllowedRole: ROLES.FULL_CONTROL
    }
  },
  {
    id: 'companyView',
    key: 'companyView',
    path: `${paths.companies}/:id/view`,
    exact: true,
    secure: true,
    component: CompanyView,
    minPermissions: {
      minAllowedRole: ROLES.VIEW_ONLY
    }
  }
];

export default { navRoutes, allRoutes };
